import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    expiresAt: String,
    endDemoUrl: String
  };

  connect() {
    this.startChecking();
  }

  checkSessionExpiration() {
    if (this.hasExpiresAtValue) {
      const expiration = new Date(this.expiresAtValue).getTime();
      const now = Date.now();
      if (now >= expiration) {
        window.location.href = this.endDemoUrl;
      }
    }
  }

  startChecking() {
    // Check every 5 minutes
    this.intervalId = setInterval(this.checkSessionExpiration.bind(this), 3000);
  }

  disconnect() {
    clearInterval(this.intervalId);
  }
}